import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import UserLayout from '../../components/user/UserLayout';
import AddWidgetForm from '../../components/AddWidgetForm';
import WidgetList from '../../components/WidgetList';

export default function UserWidgetsPage() {
  const [refresh, setRefresh] = useState(false);

  return (
    <UserLayout
      title="My Widgets"
      subtitle="Create, manage, and monitor your chat widgets"
    >
      <Card className="user-card p-4 mb-4">
        <div className="user-section-title">Create New Widget</div>
        <AddWidgetForm onWidgetCreated={() => setRefresh(!refresh)} />
      </Card>

      <Card className="user-card p-4">
        <div className="user-section-title">Existing Widgets</div>
        <WidgetList key={String(refresh)} detailsRouteBase="/dashboard/widgets" />
      </Card>
    </UserLayout>
  );
}
